/**
 * The two parts of a split bonus, in one colour each wherever they are drawn
 * (the standings' legend, the split prize's rows): blue for spend, violet for
 * videos launched.
 */
export const SPEND_TONE = "var(--brand)";
export const OUTPUT_TONE = "var(--series-4)";
